const mixin = {
  methods: {
    executeDocstreamJSAction (action, param) {
      if (action) {
        if (typeof (window[action]) === 'function') {
          window[action](param)
        } else if (window.opener && typeof (window.opener[action]) === 'function') {
          window.opener[action](param)
        } else if (typeof (window.parent[action]) === 'function') {
          window.parent[action](param)
        } else if (window.parent && window.parent.getTop && window.parent.getTop().DS && window.parent.getTop().DS.PermaLinks && typeof (window.parent.getTop().DS.PermaLinks[action]) === 'function') {
          window.parent.getTop().DS.PermaLinks[action](param)
        } else if (window.opener.parent && window.opener.parent.getTop && window.opener.parent.getTop()[action] && typeof (window.opener.parent.getTop()[action]) === 'function') {
          window.opener.parent.getTop()[action](param)
        }
      }
    },
    sanitizerHTML (value) {
      var element = window.document.createElement('div')
      element.innerText = value
      return element.innerHTML
    },
    reloadIframe (targetIframe, param1, param2 = null) {
      let targetWindow = null
      let rootWindow = null

      if (window.opener) {
        // If window.opener is not null, the current page is opened as a dialog.
        // In this case we need to get a reference to the topmost window.
        targetWindow = window.opener
      } else if (window.parent) {
        // If window.parent is not null, the current page is loaded as an iframe.
        targetWindow = window.parent
      } else {
        // This is the top page.
        targetWindow = window
      }
      // Find the root window.
      if (typeof (targetWindow.getTop) === 'function') {
        rootWindow = targetWindow.getTop()
      }

      if (rootWindow != null) {
        if (typeof (rootWindow[targetIframe]) === 'function') {
          if (param1 !== null && param1 !== undefined) {
            rootWindow[targetIframe](param1, param2)
          } else {
            rootWindow[targetIframe]()
          }
        } else {
          console.log(`Function ${targetIframe} not found in rootWindow.`)
        }
      } else {
        console.log('Root window cannot be determined.')
      }
    },
    getExtensionImage (extension) {
      let imageTag = ''
      switch (extension) {
        case '':
          imageTag = 'paperdocument.gif'
          break

          // Powerpoint
        case 'odp':
        case 'pot':
        case 'potm':
        case 'potx':
        case 'ppa':
        case 'ppt':
        case 'pptm':
        case 'pptx':
        case 'pps':
        case 'ppsm':
        case 'ppsx':

          imageTag = 'ppt.png'
          break

          // Text files
        case 'doc':
        case 'docx':
        case 'docm':
        case 'dotm':
        case 'odt':

          imageTag = 'doc.png'
          break

        case 'dot': imageTag = 'dot.png'; break
        case 'dotx': imageTag = 'dotx.png'; break
        case 'txt':
        case 'rtf':
        case 'log':

          imageTag = 'txt.png'
          break

          // Spreadsheet
        case 'ods':
        case 'xla':
        case 'xlsb':
        case 'xlam':
        case 'xls':
        case 'xlsx':

          imageTag = 'xls.png'
          break

        case 'xlt':
        case 'xltx':

          imageTag = 'xlt.png'
          break

        case 'xlsm': imageTag = 'xlsm.png'; break
        case 'xltm': imageTag = 'xltm.png'; break

          // Images
        case 'dwg': imageTag = 'dwg.png'; break
        case 'bmp':
        case 'dib':

          imageTag = 'bmp.png'
          break

        case 'gif': imageTag = 'gif.png'; break
        case 'jfif':
        case 'jpg':
        case 'jpe':
        case 'jpeg':

          imageTag = 'jpg.png'
          break

        case 'png': imageTag = 'png.png'; break

        case 'tif':
        case 'tiff':

          imageTag = 'gif.png'
          break

          // Compression
        case 'zip':
        case 'rar':
        case 'tar':

          imageTag = 'zip.png'
          break

          // Database
        case 'gwi': imageTag = 'gwi.png'; break
        case 'mdb': imageTag = 'mdb.png'; break
        case 'db':
        case 'dbf':
        case 'mdf':
        case 'ldf':
        case 'sql':

          imageTag = 'db.png'
          break

          // Executable
        case 'exe':
        case 'com':
        case 'bat':
        case 'cmd':

          imageTag = 'exe.png'
          break

          // Mail
        case 'eml': imageTag = 'eml.png'; break
        case 'msg': imageTag = 'msg.gif'; break
        case 'pst': imageTag = 'pst.png'; break

          // HTML / web
        case 'htm': imageTag = 'htm.png'; break
        case 'html': imageTag = 'htm.png'; break
        case 'css': imageTag = 'css.png'; break
        case 'js': imageTag = 'js.png'; break
        case 'php': imageTag = 'php.png'; break

          // Video
        case 'avi':
        case 'mkv':
        case 'mov':
        case 'ogv':
        case 'webm':
        case 'wmv':

          imageTag = 'avi.png'
          break

        case 'mp2':
        case 'mp4':
        case 'mpe':
        case 'mpeg':
        case 'mpg':
        case 'mpv':
        case 'm2v':

          imageTag = 'mpg.png'
          break

          // Audio
        case 'aif':
        case 'aiff':
        case 'iff':
        case 'ogg':
        case 'oga':
        case 'mogg':
        case 'mpa':
        case 'wav':
        case 'wma':

          imageTag = 'wav.png'
          break

        case 'mp3': imageTag = 'mp3.png'; break

          // Vector image
        case 'ai': imageTag = 'ai.png'; break
        case 'eps': imageTag = 'ai.png'; break
        case 'psd': imageTag = 'psd.png'; break
        case 'svg': imageTag = 'jpg.png'; break
        case 'vsd': imageTag = 'vsd.png'; break

          // Page layout
        case 'indd': imageTag = 'idd.png'; break
        case 'pdf': imageTag = 'pdf.png'; break

          // V-Cards
        case 'vcf': imageTag = 'vcf.png'; break

          // CAD
        case 'dxf': imageTag = 'dxf.png'; break
        case 'dwf': imageTag = 'dwf.png'; break

          // Project management
        case 'mpp': imageTag = 'mpp.png'; break

          // Programming
        case 'bcb': imageTag = 'bcb.png'; break

          // Adobe acrobat
        case 'jdf': imageTag = 'jdf.png'; break

          // Adobe after effects
        case 'aep': imageTag = 'aep.png'; break

          // Autodesk
        case 'ipt': imageTag = 'ipt.png'; break

          // Industry foundation classes
        case 'ifc': imageTag = 'ifc.png'; break
        case 'ifcxml': imageTag = 'ifc.png'; break
        case 'ifczip': imageTag = 'ifc.png'; break

          // Unknown
        case 'cmt': imageTag = 'comment.gif'; break
        case 'jmf': imageTag = 'jmf.png'; break
        case 'rvt': imageTag = 'rvt.png'; break
        case 'smc': imageTag = 'smc.png'; break
        case 'bcf': imageTag = 'bcf.png'; break
        case 'bcfzip': imageTag = 'bcf.png'; break

        default: imageTag = 'file_empty.png'; break
      }

      return imageTag
    },
    getColumnImage (Value) {
      let imageTag = 'space.gif'
      const iconMapping =
      {
        'SpaceIcon': 'space.gif',
        'NewCommentNLIcon': 'newcomment_NL.gif',
        'NewCommentENIcon': 'newcomment_EN.gif',
        'OldCommentIcon': 'commentOldVersion.gif',
        'CommentIcon': 'comment.gif',
        'UnfinishedCommentIcon': 'versionsascomment.gif',
        'PreliminaryIcon': 'preliminary.gif',
        'RejectedIcon': 'rejected.gif',
        'ApprovedWithCommentIcon': 'approvedwithcomment.gif',
        'ApprovedIcon': 'approved.gif',
        'ForApprovalIcon': 'forapproval.gif',
        'FrozenIcon': 'frozen.gif',
        'LockedIcon': 'locked.gif',
        'EditIcon': 'edit.gif',
        'EditOtherPcIcon': 'edit_other_pc.gif',
        'MarkedIcon': 'marked.gif',
        'StampedIcon': 'stamped.gif',
        'StampedOldVersionIcon': 'stamped_oldversion.gif',
        'QRRevoked': 'qrcode_revoked.png',
        'QRCodeIcon': 'qrcode.png',
        'QRCodeOldVersionIcon': 'qrcode_oldversion.png',
        'SnagstreamDrawingOldVersionIcon': 'snagstreamDrawingOldVersion.png',
        'SnagstreamDrawingIcon': 'snagstreamDrawing.png',
        'ProcedureOldVersionIcon': 'procedure_oldVersion.gif',
        'ProcedureIcon': 'procedure.gif',
        'ProcedureRedOldIcon': 'procedure_red_old.png',
        'ProcedureRedIcon': 'procedure_red.png',
        'ProcedureBlackOldIcon': 'procedure_black_old.png',
        'ProcedureBlackIcon': 'procedure_black.png',
        'ProcedureGreenOldIcon': 'procedure_green_old.png',
        'ProcedureGreenIcon': 'procedure_green.png',
        'ProcedureMixedIcon': 'procedure_mixed.png',
        'BuildStatusFailed': '12build_failed.png',
        'BuildStatusUploading': '12build_uploading.png',
        'BuildStatusOk': '12build_ok.png',
        'BuildStatusOld': '12build_old.png',
        'WaitForRefresh': 'waitforrefresh.gif',
        'BimstreamOldVersionIcon': 'bimstream_old_version.png',
        'BimstreamPendingIcon': 'bimstream_pending.png',
        'BimstreamApprovedIcon': 'bimstream_approved.png',
        'BimstreamFailedIcon': 'bimstream_failed.png',
        'NewDocumentNLIcon': 'newDocument_NL.gif',
        'NewDocumentENIcon': 'newDocument_EN.gif',
        'newDocument_NL.gif': 'newDocument_NL.gif',
        'newDocument_EN.gif': 'newDocument_EN.gif'
      }
      try {
        let result = iconMapping[Value]
        if (result != null && result !== undefined) {
          return result
        }
      } catch (err) { }
      return imageTag
    },
    getColumnHeaderImage (Value) {
      let imageTag = null
      let newDocIcon
      switch (this.$i18n.locale) {
        case 'nl':
          newDocIcon = 'newDocument_NL.gif'
          break
        case 'en' :
          newDocIcon = 'newDocument_EN.gif'
          break
        default :
          newDocIcon = 'newDocument_EN.gif'
          break
      }
      const iconMapping =
      {
        'Comment': 'comment.gif',
        'Approved': 'approved.gif',
        'Final': 'frozen.gif',
        'Locked': 'locked.gif',
        'Editing': 'edit.gif',
        'Marked': 'marked.gif',
        'Stamped': 'stamped.gif',
        'QRCode': 'qrcode.png',
        'SnagstreamDrawing': 'snagstreamDrawing.png',
        'Procedure': 'procedure.gif',
        'ProcedureStatus': 'procedure_green.png',
        'BuildStatus': '12build_ok.png',
        'WaitForServerRefresh': 'waitforrefresh.gif',
        'BimstreamStatus': 'bimstream_approved.png',
        'IsNewDocument': newDocIcon
      }
      try {
        let result = iconMapping[Value]
        if (result != null && result !== undefined) {
          return result
        }
      } catch (err) { }
      return imageTag
    },
    generateHash (str) {
      let hash = 0
      let i = null
      let chr = null
      for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i)
        hash = ((hash << 5) - hash) + chr
        hash |= 0
      }
      return hash
    },
    getDocumentKey (row) {
      return `${row.Id}-${row.LastDocumentVersionId}-${row.index}`
    },
    checkNotEmpty (folderName) {
      return folderName !== ''
    },
    checkFolderNameChars (folderName) {
      let notAllowedCharacters = /\\|\/|:|\*|\?|"|<|<|>|\|/
      return !notAllowedCharacters.test(folderName)
    },
    checkNotTooLong (folderName) {
      return folderName.length <= 250
    },
    // Validates all checks
    validFolderName (folderName) {
      return (
        this.checkNotEmpty(folderName) &&
        this.checkFolderNameChars(folderName) &&
        this.checkNotTooLong(folderName)
      )
    }
  }
}
export default mixin



// WEBPACK FOOTER //
// ./src/mixins/index.js